
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dGO9h", function(module, exports) {
/* CopySpacePermissionsForLegacyNewSpace.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jTxSS = parcelRequire("jTxSS");


var $h82at = parcelRequire("h82at");


var $euL71 = parcelRequire("euL71");


var $joCMa = parcelRequire("joCMa");


var $bQm3c = parcelRequire("bQm3c");


var $dsz8u = parcelRequire("dsz8u");


var $crGnL = parcelRequire("crGnL");

const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID = 'create-dialog';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_MAKE_PRIVATE_CHECKBOX_ID = 'permission-private';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_PERMISSIONS_SUBFORM_ID = 'space-form-permissions';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEAM_DESCRIPTION_ID = 'team-description';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEXTAREA_CSS_SELECTOR = `#${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} textarea`;
const $4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_ALL_FIELDS_VALID_ID = 'copy-space-permissions-fields-valid';
const $4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_SOURCE_FIELD_ID = 'copy-space-permissions-key-for-create';
const $4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID = 'new-space-permissions-portal-container';
const $4baf451c3e5c454f$var$TEAM_SPACE_TEMPLATE_TEAM_MEMBERS_ID = 'team-members';
const $4baf451c3e5c454f$var$CHANGE_LISTENER_CSS_CLASSNAME = 'portal-change-listener';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEAM_DESCRIPTION_MAX_ROWS = 2;
const $4baf451c3e5c454f$var$i18n = (0, $h82at.defineMessages)({
    optionSelectLabel: {
        id: "copy-space-permissions.for-new-space.option-select.label",
        defaultMessage: "Space permissions"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4baf451c3e5c454f$var$CopySpacePermissionsPanel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkv77o _kqswstnw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4baf451c3e5c454f$var$CopySpacePermissionsSubpanel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqsw1n9t",
            __cmplp.className
        ])
    });
});
const $4baf451c3e5c454f$var$SpaceTemplateCssOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, `
      /********************************************************************/
      /* Begin section for Copy Space Permissions on Create Space Dialog  */
      /********************************************************************/

      #${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} .dialog-wizard-page-main {
        padding-top: 10px;
      }

      #${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} .dialog-wizard-page-description {
        padding-top: 10px;
      }

      #${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} .error {
        margin-top: 3px;
      }

      /* Force the Team Space Template's Team Member field to have maximum height of 2 rows.
        The unmodified version of this field has unlimited height, which gets ugly especially
        with the additional Copy Space Permissions now below it. */
      #${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} ul.select2-choices {
        max-height: 54px;
        overflow: auto;
      }
   `);
const $4baf451c3e5c454f$var$getObjectConstructorName = (object)=>object?.constructor?.name;
const $4baf451c3e5c454f$export$5dc791f41eb205df = ()=>{
    /* Keep track of whether the Create New Space wizard has been displayed yet. This is done for
     efficiency, so we don't have to search the DOM for the portal target if that wizard hasn't been
     shown yet.  However, once the wizard is exited this state does not get reset until the page is
     refreshed */ const [targetWizardActivated, setTargetWizardActivated] = (0, $42omo.useState)(false);
    const [, setLastRefresh] = (0, $42omo.useState)(0);
    const forceUpdate = ()=>{
        setLastRefresh(Date.now());
    }; /* Passes the source Space key to the server-side rendered (SSR) part of the page by changing
        the value of a hidden field on the SSR side, which the SSR Javascript code will read and add
        to the Create New Space request to the backend */ 
    const setCreateSpaceSourceKeyInSSR = (sourceSpaceKey)=>{
        const sourceField = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_SOURCE_FIELD_ID);
        if ($4baf451c3e5c454f$var$getObjectConstructorName(sourceField) === 'HTMLInputElement') {
            const sourceInputField = sourceField;
            sourceInputField.value = sourceSpaceKey;
        }
    };
    /* Updates the hidden "copy-space-permissions-fields-valid" field on the legacy (SSR) side of
     the page to indicate whether the React-based controls have valid settings */ const setReactFieldsValidInSSR = (option, sourceSpace)=>{
        const legacySpacePermissionsValidField = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_ALL_FIELDS_VALID_ID);
        if ($4baf451c3e5c454f$var$getObjectConstructorName(legacySpacePermissionsValidField) === 'HTMLInputElement') {
            // Set the value in the SSR field
            // (Any non-empty string value means "valid")
            const inputField = legacySpacePermissionsValidField;
            inputField.value = option && (0, $dsz8u.isSourceSpaceValid)({
                option: option,
                sourceSpace: sourceSpace
            }) ? 'true' : ''; // Tell the legacy UI code that the validity field has changed
            // (Note that while IE 11 doesn't support CustomEvent constructors, our main webpack config has the "events-polyfill" included)
            inputField.dispatchEvent(new CustomEvent('change', {
                bubbles: true
            }));
        }
    };
    /* We have to hide the "permission-private" checkbox and its' label, etc. every time we render our new UI
     because when this component's render is called we know that the SSR target has re-rendered and made the
     checkbox is visible again */ const hideCreateSpaceOldPermissions = ()=>{
        const oldPermissions = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_LEGACY_PERMISSIONS_SUBFORM_ID);
        if (oldPermissions) oldPermissions.classList.add('hidden');
    };
    /* The different Space templates' SSR wizard pages may have a "description" or other textarea
     controls on them that by default are resizable - but because our React component will float
     over the SSR wizard page (so our dropdowns don't get cut off by "overflow: hidden") the
     textareas could be resized underneath our React component.  This method finds any such
     textareas and makes them fixed-size - which is okay because they will still scroll if the
     user types too much in them */ const lockCreateSpaceTextareasSize = ()=>{
        document.querySelectorAll($4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEXTAREA_CSS_SELECTOR).forEach((element)=>{
            if ($4baf451c3e5c454f$var$getObjectConstructorName(element) === 'HTMLTextAreaElement') {
                const textareaElement = element;
                textareaElement.style.resize = 'none';
            }
        });
    };
    /* On SSR wizard page for the Team Space template, when the user chooses to add a team member
     to the template the control for the team members grows and then shrinks back again. Our
     portal gets re-rendered when the it the team members control grows (and our fields are psuhed
     down) but it is not re-rendered when it shrinks again.  This leaves a gap between the existing
     fields and our fields, and may also push our fields off the bottom of the dialog (especially
     if there are error messages visible).  We can hook into the events generated by the team
     member control to force a re-render when the selection is done. */ /* Note that the team member control is a very old AUI component "user-group-select2" component
     found in the "confluence-ui-components" repo, so modifying the control itself to not expand-
     then-shrink seems risky.  And while this component is built on top of "Select2", which is an
     old jQuery replacement for the standard HTML <select> control.  But as the AUI user group
     control doesn't user all of the Select control functionally (the list of names isn't actually
     in the Select2 control's dropdown; AUI has created a separate div for that), we can't listen
     for the standard "select2-selected" event.  Instead we listen for when the contents of the
     controls changes */ const renderOnTeamTemplateMembersChange = ()=>{
        // Use an empty CSS class as a flag to indicate whether we've already connected the listener
        const teamMembersControl = document.getElementById($4baf451c3e5c454f$var$TEAM_SPACE_TEMPLATE_TEAM_MEMBERS_ID);
        if (teamMembersControl && !teamMembersControl.classList.contains($4baf451c3e5c454f$var$CHANGE_LISTENER_CSS_CLASSNAME)) {
            teamMembersControl.classList.add($4baf451c3e5c454f$var$CHANGE_LISTENER_CSS_CLASSNAME);
            teamMembersControl.onchange = ()=>forceUpdate();
        }
    };
    /* We also need to adjust the Team Space Template's "Description" field's height or the portal
     may get rendered past the end of the dialog */ const adjustTeamTemplateDescriptionSize = ()=>{
        const teamTemplateDesciption = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEAM_DESCRIPTION_ID);
        if ($4baf451c3e5c454f$var$getObjectConstructorName(teamTemplateDesciption) === 'HTMLTextAreaElement') {
            const teamDescriptionTextarea = teamTemplateDesciption;
            teamDescriptionTextarea.rows = $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEAM_DESCRIPTION_MAX_ROWS;
        }
    }; /* Move the portal target to be the last sibling in its' parent's list of children.  This is
        a hack to make components rendered into the portal appear after any other child elements,
        as some of the Space templates call the "createSpaceFormFields" template (which contains
        our portal target) and then add their extra fields after that - but our UI designers want
        our new added components to be last in the form.  And since most of the Space templates
        are plugins in other repos (and others may be added at any time) we have no easy way to
        add our portal to all of them. Therefore at runtime we'll just make sure our portal
        target is after everything else in the parent form */ 
    const makePortalTargetLastSibling = ()=>{
        const portalTarget = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID);
        if (portalTarget) {
            const parent = portalTarget.parentElement;
            if (parent) parent.appendChild(portalTarget);
        }
    };
    /* Passes the "make private" flag to the server-side rendered (SSR) part of the page by changing
     the value of a hidden checkbox on the SSR side, which the SSR Javascript code will read and add
     to the Create New Space request to the backend */ const setMakePrivateInSSR = (makePrivate)=>{
        const privateCheckbox = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_LEGACY_MAKE_PRIVATE_CHECKBOX_ID);
        if ($4baf451c3e5c454f$var$getObjectConstructorName(privateCheckbox) === 'HTMLInputElement') {
            const privateCheckboxInput = privateCheckbox;
            privateCheckboxInput.checked = makePrivate;
        }
    };
    const onChange = ({ option: option, sourceSpace: sourceSpace })=>{
        /* When the "make private" flag changes, pass the flag to its' hidden field on the SSR side of the page */ setMakePrivateInSSR(option === (0, $crGnL.Option).ONLY_VISIBLE_TO_ME); /* Because we are passing the selected source Space's key to the SSR side of the page in a
                                                                 hidden field on the SSR side, we need to copy the current setting to the SSR field when
                                                                 copying is selected and make sure to clear the SSR field's value when deselected */ 
        setCreateSpaceSourceKeyInSSR(sourceSpace.key); // Update the enable state of legacy UI's "Create" button based the validity of our fields
        setReactFieldsValidInSSR(option, sourceSpace);
    };
    const newSpaceWizardMessageHandler = (0, $42omo.useCallback)(()=>{
        /* If we haven't already seen the portal target yet, check if this is a wizard page with
        our portal target on it */ if (!targetWizardActivated && document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID)) setTargetWizardActivated(true);
         // Always force a re-render, as React won't recognize when the SSR part of the page redraws
        forceUpdate();
    }, [
        targetWizardActivated
    ]);
    // Customize the legacy SSR after every render for our new UI elements, if our portal target is visible
    (0, $42omo.useEffect)(()=>{
        if (targetWizardActivated && document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID)) {
            hideCreateSpaceOldPermissions();
            makePortalTargetLastSibling();
            lockCreateSpaceTextareasSize();
            adjustTeamTemplateDescriptionSize();
            renderOnTeamTemplateMembersChange();
        }
    });
    /* The Create New Space wizard is rendered dynamically on the browser at runtime (even though
     the Javascript code to do so is in the server-rendered pages) and that means we won't find
     the portal target on this page during the initial React render.  And since the wizard is
     plain Javascript, the React component tree does not get notified or re-rendered when the
     wizard is displayed.  So we need to have the wizard tell us when it has been rendered via
     the legacy-message-queue. This hook sets up the message handler for that event, so it only
     needs to be called once, at initialization time. But added newSpaceWizardMessageHandler to
     dependency array for eslint purposes */ /* (Note that this component needs to in the DOM tree in classic:SPA pages, next:SPA pages
     and SSR pages, since there are "Create new space" buttons on the "Space Directory" page
     which is an SSR page, and on the "Activity" ("/discover" route) page which is a SPA page,
     and new "Home" page ("/wiki" route) */ (0, $42omo.useEffect)(()=>{
        // set the callback for when the Create New Space wizard is rendered
        (0, $joCMa.getLegacyMessageQueue)().then((legacyMessageQueue)=>{
            legacyMessageQueue.push({
                type: 'ATLASSIAN_CONFLUENCE_NEW_SPACE_REGISTER_CALLBACK',
                payload: newSpaceWizardMessageHandler
            });
        });
    }, [
        newSpaceWizardMessageHandler
    ]);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (targetWizardActivated) {
        const portalTarget = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID);
        if (portalTarget) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4baf451c3e5c454f$var$CopySpacePermissionsPanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4baf451c3e5c454f$var$CopySpacePermissionsSubpanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dsz8u.CopySpacePermissionsSelector), {
            analyticsEventSourceName: "createSpaceModal",
            defaultOption: (0, $crGnL.Option).DEFAULT_PERMISSIONS,
            isDisabled: edition === (0, $euL71.ConfluenceEdition).FREE,
            label: $4baf451c3e5c454f$var$i18n.optionSelectLabel,
            onChange: onChange,
            options: (0, $crGnL.getOptionsByEdition)(edition),
            showUpsell: edition === (0, $euL71.ConfluenceEdition).STANDARD,
            renderGuestsWarning: true,
            validationPlaceholder: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4baf451c3e5c454f$var$SpaceTemplateCssOverride, null)) : null, portalTarget);
    }
    // If we couldn't render into the portal target or didn't need to, then don't render anything
    return null;
};
module.exports["CopySpacePermissionsForLegacyNewSpace"] = $4baf451c3e5c454f$export$5dc791f41eb205df;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("eJhXX", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $fWkVZ = parcelRequire("fWkVZ");


var $w033M = parcelRequire("w033M");


var $icMDs = parcelRequire("icMDs");

function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}
module.exports["getUserPrivilegeFromQuery"] = $a7000458c02582d2$export$d036114e4ad5c4c3;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("icMDs", function(module, exports) {
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});
module.exports["UserPrivilege"] = $296e2d91f769f195$export$fa8745fb6d256802;

});

parcelRegister("gLeLL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $j4WDj = parcelRequire("j4WDj");


var $4WmbV = parcelRequire("4WmbV");

const $103cc6a380e10ff8$export$a36903bd214cec06 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    let children;
    let customPadding;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ children: children, withGradient: t1, topBanner: t2, customPadding: customPadding, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = customPadding;
        $[3] = props;
        $[4] = t1;
        $[5] = t2;
    } else {
        children = $[1];
        customPadding = $[2];
        props = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    const withGradient = t1 === undefined ? true : t1;
    const topBanner = t2 === undefined ? false : t2;
    let t3;
    if ($[6] !== children) {
        t3 = !!children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$ChildrenLayout, null, children);
        $[6] = children;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== props) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true
        });
        $[8] = props;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== customPadding || $[11] !== t3 || $[12] !== t4 || $[13] !== topBanner || $[14] !== withGradient) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$Layout, {
            withGradient: withGradient,
            topBanner: topBanner,
            customPadding: customPadding,
            "data-testid": "section-message"
        }, t3, t4);
        $[10] = customPadding;
        $[11] = t3;
        $[12] = t4;
        $[13] = topBanner;
        $[14] = withGradient;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : ({ children: children, withGradient: withGradient = true, topBanner: // TODO: refactor topBanner and customPadding per https://product-fabric.atlassian.net/browse/USD-337
// for now since we only support 2 different cases, we give a boolean, going forward, if more use cases surface, we can revisit and design a better API
topBanner = false, customPadding: customPadding, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$Layout, {
        withGradient: withGradient,
        topBanner: topBanner,
        customPadding: customPadding,
        "data-testid": "section-message"
    }, !!children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$ChildrenLayout, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true
    }));
const $103cc6a380e10ff8$var$ChildrenLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2hwx1ejb _p12f68cl _1ul968cl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx1ejb _p12f68cl _1ul968cl",
            __cmplp.className
        ])
    });
});
const $103cc6a380e10ff8$var$gradientBackground = `linear-gradient(84.09deg,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_START)} 0%,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_END)} 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $103cc6a380e10ff8$var$Layout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { withGradient: withGradient, customPadding: customPadding, topBanner: topBanner, ...__cmpldp } = __cmplp;
        const t3 = (0, $7sObp.default)($103cc6a380e10ff8$var$gradientBackground);
        let t4;
        bb0: {
            if (__cmplp.customPadding) {
                t4 = __cmplp.customPadding;
                break bb0;
            }
            if (__cmplp.topBanner) {
                t4 = "var(--ds-space-150, 12px) var(--ds-space-300, 24px)";
                break bb0;
            }
            t4 = "var(--ds-space-200, 16px) var(--ds-space-300, 24px)";
        }
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1p4ue13": t3,
                "--_krzptn": (0, $7sObp.default)(t4)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt41r3g _2rko12b0 _1e0c1txw _1bsb1osq _vchhusvi _kqswh2mm",
                __cmplp.withGradient ? "_11q7hu7i" : "_11q7glyw",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withGradient: withGradient, customPadding: customPadding, topBanner: topBanner, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1p4ue13": (0, $7sObp.default)($103cc6a380e10ff8$var$gradientBackground),
            "--_krzptn": (0, $7sObp.default)((()=>{
                if (__cmplp.customPadding) return __cmplp.customPadding;
                if (__cmplp.topBanner) return `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"}`;
                return `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt41r3g _2rko12b0 _1e0c1txw _1bsb1osq _vchhusvi _kqswh2mm",
            __cmplp.withGradient ? "_11q7hu7i" : "_11q7glyw",
            __cmplp.className
        ])
    });
});
module.exports["SectionMessage"] = $103cc6a380e10ff8$export$a36903bd214cec06;

});

parcelRegister("caYQd", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a745dfd537cdace3$var$LoadingSpaceSelector = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tke1ylp",
            __cmplp.className
        ])
    });
});

const $a745dfd537cdace3$export$ae81af835e192ac4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SLEHS",
    name: "SpaceSelector",
    loader: async ()=>(await (parcelRequire("kU8fx"))).SpaceSelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a745dfd537cdace3$var$LoadingSpaceSelector, null)
});
module.exports["SpaceSelector"] = $a745dfd537cdace3$export$ae81af835e192ac4;

});

parcelRegister("kU8fx", function(module, exports) {

let $f37f6fd1b3246c85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f37f6fd1b3246c85$var$load("5tmW9"),
    $f37f6fd1b3246c85$var$load("6wr18"),
    $f37f6fd1b3246c85$var$load("dtpmo"),
    $f37f6fd1b3246c85$var$load("6aTYS"),
    $f37f6fd1b3246c85$var$load("ffEVr"),
    $f37f6fd1b3246c85$var$load("jXx9i"),
    $f37f6fd1b3246c85$var$load("jYUNl"),
    $f37f6fd1b3246c85$var$load("foy8I"),
    $f37f6fd1b3246c85$var$load("hogcU"),
    $f37f6fd1b3246c85$var$load("2vAWg"),
    $f37f6fd1b3246c85$var$load("7cABH"),
    $f37f6fd1b3246c85$var$load("9jjvO"),
    $f37f6fd1b3246c85$var$load("i8eeg"),
    $f37f6fd1b3246c85$var$load("iFdoJ"),
    $f37f6fd1b3246c85$var$load("7EorR"),
    $f37f6fd1b3246c85$var$load("hhss7"),
    $f37f6fd1b3246c85$var$load("Wowvf"),
    $f37f6fd1b3246c85$var$load("4Nzvy"),
    $f37f6fd1b3246c85$var$load("h3ABO"),
    $f37f6fd1b3246c85$var$load("kC80R"),
    $f37f6fd1b3246c85$var$load("eMbU0")
]).then(()=>parcelRequire('bHtQ2'));

});

parcelRegister("iquRY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), t0);
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<fca40edcd431a6c5f3bb28df1ad0109c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("2VHSy", function(module, exports) {
function $d84dbdb638867381$export$71e2f6367fb20728(createAnalyticsEvent, eventSource, defaultAttributes) {
    return (payload)=>{
        const { data: data } = payload;
        if (!data) throw new Error('payload.data should be defined');
        return createAnalyticsEvent({
            ...payload,
            data: {
                ...data,
                source: eventSource,
                attributes: {
                    ...defaultAttributes,
                    ...data.attributes
                }
            }
        });
    };
}
module.exports["createAnalyticsEventFactory"] = $d84dbdb638867381$export$71e2f6367fb20728;

});


//# sourceMappingURL=CopySpacePermissionsForLegacyNewSpace.b7af5e9a.js.map
